import { CallbackObject } from 'api/core/get-page-function';
import { GetReceptionsVm } from './get-receptions.vm';
import { plainToClass } from 'class-transformer';
import { instance } from 'api/core';
import { AxiosResponse } from 'axios';
import { ReceptionStatus } from './reception.vm';

export const getReceptions = async (
  offset: string,
  status: ReceptionStatus | null,
  supplier: string | null,
  receiverId: string | null,
  warehouseId: string | null,
  callback: CallbackObject<GetReceptionsVm>
) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  if (status) {
    config.params.status = status;
  }

  if (supplier) {
    config.params.supplierId = supplier;
  }

  if (receiverId) {
    config.params.receiverId = receiverId;
  }

  if (warehouseId) {
    config.params.warehouseId = warehouseId;
  }

  try {
    const res: AxiosResponse = await instance.get(`/reception/receptions`, config);
    callback.success(plainToClass(GetReceptionsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
